import {FC, useRef, useState} from "react";
import {CloseCircleIcon, Microphone2Icon} from "../atoms/Icon";
import Button from "../atoms/Button.tsx";
import {createRecorder, Recorder} from "../helpers/recorder.ts";
import {transcribe} from "../api/transcription.ts";
import SmallLoadingSpinner from "../atoms/SmallLoadingSpinner.tsx";

interface Props {
    onTranscript: (transcript: string) => void
}

export const ChatMicrophoneInput: FC<Props> = ({ onTranscript }) => {
    const [recording, setRecording] = useState(false);
    const recorder = useRef<Recorder | null>(null);
    const [loading, setLoading] = useState(false);

    const startRecording = async () => {
        recorder.current = await createRecorder();
        setRecording(true);
    }

    const stopRecording = async () => {
        setRecording(false);
        if (recorder.current) {
            const audio = await recorder.current.stopRecording();
            setLoading(true);
            const result = await transcribe(audio);
            setLoading(false);
            onTranscript(result);
        }
    }

    if (recording) {
        return <Button variant="primary" size="circle" onClick={stopRecording}><CloseCircleIcon size={20} /></Button>
    }

    if (loading) {
        return <Button variant="outline" size="circle" onClick={startRecording}>
            <SmallLoadingSpinner />
        </Button>
    }

    return <Microphone2Icon size={20} onClick={startRecording} />
}

export default ChatMicrophoneInput;